export const FIRST_REPORT_YEAR = 2021;

export function getCurrentReportPeriod(date = new Date()) {
    return {
        year: date.getFullYear(),
        quarter: Math.floor(date.getMonth() / 3) + 1,
    };
}

export function getAvailableReportYears(currentYear = new Date().getFullYear()) {
    return Array.from(
        { length: currentYear - FIRST_REPORT_YEAR + 1 },
        (_, index) => FIRST_REPORT_YEAR + index,
    );
}